<template>
	<div class="header transition500" :style="{backgroundColor:'white'}">
		<div class="header_content">
			<div class="header_left cursorPointer">
				<div class="logo">
					 <img src="https://ddlg-zhongtai-dev-1257088705.cos.ap-guangzhou.myqcloud.com/project/50b5dfbc-68d8-44e5-8cc6-6062aef911f5.png"  />
				</div>
			</div>
				<div :class="['header_right_balck', { 'menu-hidden': menuHidden }]" style="max-height: 500px" @mouseleave="menuHidden=false">
          <div
            v-for="item in displayNavList"
            :key="item.value"
            :class="['nav-wrap', { active: item.value === '1' }]"
            @mouseenter="handleNavHover(item)"
            @mouseleave="handleNavLeave(item)"
            @click="checkHeaderTab(item)"
          >
            <div class="item cursorPointer">{{$t(item.labelKey)}}</div>
          </div>
          <div :class="['about-menu', { show: aboutMenuVisible }]" @mouseenter="aboutMenuVisible = true" @mouseleave="aboutMenuVisible = false">
            <div class="inner-xc section">
              <div class="desc">
                <div class="title">{{$t('header.aboutMenu.title')}}</div>
                <div class="content">
                  {{$t('header.aboutMenu.desc')}}
                </div>
              </div>
              <div class="navbar">
                <div class="xc-navbar">
                  <a href="/home/about-xc#qyjj" class="item"><span class="arr">>></span><span>{{$t('header.aboutMenu.intro')}}</span></a>
                  <a href="/home/about-xc#ryzz" class="item"><span class="arr">>></span><span>{{$t('header.aboutMenu.honor')}}</span></a>
                  <a href="/home/about-xc#gltd" class="item"><span class="arr">>></span><span>{{$t('header.aboutMenu.team')}}</span></a>
                  <a href="/home/about-xc#qywh" class="item"><span class="arr">>></span><span>{{$t('header.aboutMenu.culture')}}</span></a>
                  <a href="/home/contact-us" class="item"><span class="arr">>></span><span>{{$t('header.aboutMenu.contact')}}</span></a>
                </div>
              </div>
            </div>
          </div>
          <el-button :class="['lang-switch', { 'lang-switch-en': !isChinese }]" type="text" @click="toggleLanguage">{{$i18n.locale === 'zh-CN' ? $t('lang.switchToEn') : $t('lang.switchToZh')}}</el-button>
          <div class="productMenu transition500">
            <div class="left">
              <div v-if="item.children" class="cursorPointer" v-for="(item,index) in productMenuList" @click="checkTab(index)" >
                <p :style="{ width: leftItemWidth ? leftItemWidth + 'px' : 'auto' }">{{item.directoryName}}
                  <span v-if="index==productIndex">>></span>
                </p>
              </div>
            </div>
            <div class="right"  >
              <div  class="right_item" v-if="productMenuList[productIndex] && productMenuList[productIndex].children" v-for="vItem in (productMenuList[productIndex] && productMenuList[productIndex].children) || []">
                <div v-if="vItem && vItem.children" class="title cursorPointer">{{vItem.directoryName}}</div>
                <div  @click="clickMenuItem(cItem)" v-if="vItem && vItem.children" class="content" v-for="cItem in (vItem && vItem.children) || []">
                  <p class="cursorPointer"  >{{cItem.directoryName}}</p>
                  <p>{{cItem.description}}</p>
                </div>
              </div>
        <!-- 隐藏测量容器，用于计算最宽项宽度 -->
        <div ref="measure" class="measure" aria-hidden="true">
          <p class="mitem" v-for="item in productMenuList">{{item.directoryName}}</p>
        </div>
            </div>
          </div>
				</div>

		</div>

	</div>
</template>

<script>
import {
  getJson
} from "@/utils/axios";
	export default {
		props: {
			isJobs: {
				type: Boolean,
			}
		},
		data() {
			return {
        firstId:0,
				menuHidden: false,
				aboutMenuVisible: false,
				leftItemWidth: 0,
        productShowList: [
          {
            labelKey: 'nav.home',
            value: '0',
            linkUrl:'https://www.xchr-group.com/index.html'
          },
          {
            labelKey: 'nav.about',
            value: '1',
            linkUrl:'https://www.xchr-group.com/about_gyxc.html#qyjj'
          },
          {
            labelKey: 'nav.products',
            value: '2',
            linkUrl:''
          },
          {
            labelKey: 'nav.news',
            value: '3',
            linkUrl:'https://www.xchr-group.com/news.html#qydt'
          },
          {
            labelKey: 'nav.jobs',
            value: '4',
            linkUrl:'https://www.xchr-group.com/joinus.html'
          },
          {
            labelKey: 'nav.party',
            value: '5',
            linkUrl: 'https://www.xchr-group.com/news.html#xcdj'
          },
          {
            labelKey: 'nav.overseas',
            value: '6',
            linkUrl: ''
          }
        ],
        productIndex:0,
        productMenuList:[],
				activeName: "2",
				pathName: "/",
				city: "全国",
				cityValue: "",
				isDown: false,
				isHome: true
			};
		},
		computed: {
      isChinese() {
        const currentLocale = this.$i18n && this.$i18n.locale ? this.$i18n.locale : 'zh-CN'
        return currentLocale === 'zh-CN'
      },
      displayNavList() {
        if (this.isChinese) {
          return this.productShowList
        }
        return this.productShowList.filter(item => !['2', '3', '4', '5'].includes(item.value))
      },
		},
		methods: {
      handleNavHover(item) {
        this.aboutMenuVisible = item && item.value === '1'
      },
      handleNavLeave(item) {
        if (item && item.value === '1') {
          window.setTimeout(() => {
            if (!this.$el || !this.$el.querySelector('.about-menu:hover')) {
              this.aboutMenuVisible = false
            }
          }, 120)
        }
      },
      toggleLanguage(){
        const nextLocale = this.$i18n.locale === 'zh-CN' ? 'en' : 'zh-CN'
        this.$i18n.locale = nextLocale
        localStorage.setItem('locale', nextLocale)

        if (this.$route && this.$router) {
          this.$router.replace({
            path: this.$route.path,
            params: this.$route.params,
            query: { ...this.$route.query, lang: nextLocale },
            hash: this.$route.hash
          }).catch(() => {})
        }

        this.$nextTick(() => {
          this.$forceUpdate()
        })
      },
      checkHeaderTab(item){
        const currentLocale = (this.$i18n && this.$i18n.locale) ? this.$i18n.locale : 'zh-CN'
        const isChinese = currentLocale === 'zh-CN'
        if (item.value === '1') {
          this.aboutMenuVisible = true
        }

        // “首页”：英文/其他外语走站内首页，中文保持原外链
        if (item.value === '0' && !isChinese) {
          const query = { ...(this.$route ? this.$route.query : {}), lang: currentLocale }
          this.$router.push({ name: 'IndexHome', query }).catch(() => {})
          this.menuHidden = true
          return
        }

        // “关于”菜单：英文/其他外语走站内路由，中文保持原外链
        if (item.value === '1' && !isChinese) {
          const query = { ...(this.$route ? this.$route.query : {}), lang: currentLocale }
          this.$router.push({ name: 'AboutXc', query }).catch(() => {})
          this.menuHidden = true
          return
        }

        if (item.value === '2') {
          this.$router.push({ name: 'HeaderMenu', query: { lang: currentLocale } }).catch(() => {})
          this.menuHidden = true
          return
        }

        if (item.value === '6') {
          this.$router.push({ name: 'OverseasColumn', query: { lang: currentLocale } }).catch(() => {})
          this.menuHidden = true
          return
        }

        if(item.value!=='2' && item.value!=='6'){
          window.open(item.linkUrl)
        }
        this.menuHidden = true
      },
      clickMenuItem(item){
        console.log(item,'item')
        localStorage.setItem('firstId',item.id)
        this.$emit('click',item)
        this.menuHidden = true
        this.aboutMenuVisible = false
      },
      checkTab(index){
        this.productIndex=index;
      },
      getMenuList(){
        getJson(`/directory/productList`, {}, res => {
          if(res.code==200){
          this.productMenuList=res.rows || [];
          const list =res.rows && res.rows[0] ? res.rows[0].children || [] : [];
          const childList=list[0] ? list[0].children || [] : [];
          this.firstId=childList[0] ? childList[0].id : 0;
          // localStorage.setItem('firstId', this.firstId)
          this.$nextTick(() => {
            this.computeLeftMaxWidth();
            // 首次获取菜单后，将默认 firstId 通知父组件
            // this.$emit('click', { id: this.firstId })
          })
          }else{
            this.$message.error(res.msg)
          }
        });
      },
      computeLeftMaxWidth(){
        try{
          // 使用隐藏容器测量，避免 hover 前 display:none 导致宽度为 0
          const measure = this.$refs.measure;
          const nodes = measure ? measure.querySelectorAll('p') : [];
          let max = 0;
          nodes.forEach(n => {
            const w = n.offsetWidth;
            if(w > max){ max = w; }
          });
          this.leftItemWidth = max;
        }catch(e){
          // ignore
        }
      },
      changeCity() {},
			handleClick(tab,e) {
        console.log(tab.name,'tab')
        console.log(e,'2')
        this.activeName = tab.name;
        if(tab.name==2) return
        window.open(this.productShowList[tab.name].linkUrl)
			},
			scrollWatch() {
				const top = document.documentElement.scrollTop;
				this.isDown = top >= 700 ? true : false;
			},
		},
		created() {
      // console.log('获取详情')
      this.getMenuList()
		},
		mounted() {
			// if (!this.bgColor) {
			// 	// 监听回车按键
			// 	window.addEventListener("scroll", this.scrollWatch, true);
			// }
		},
		beforeDestroy() {
			// 监听回车按键
			window.removeEventListener("scroll", this.scrollWatch);
		}
	};
</script>

<style scoped lang="scss">
.header{
  position: relative;
}
.productMenu{
  z-index:99;
  position: absolute;
  width: 100%;
  display: none;
  top: 80px;
  left: 0;
  background-color: #1C51A3;
  padding: 40px  300px 40px 300px;
  .left{
    display: flex;
    margin-right: 100px;
    flex-direction: column;
    p{
      width: auto;
      padding: 0 12px;
      height: 30px;
      margin-bottom: 30px;
      line-height: 30px;
      background-color: #FF9800;
      color: #fff;
    }
  }
  .right{
   height: 540px;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-items: flex-start;
    margin-right: 30px;
    .right_item{
      border-left: 1px solid #fff;
      padding-left: 20px;
      text-align: left;
      width: 200px;
      .title{
        color: #fff;
        font-weight: 550;
        font-size: 24px;
        height: 40px;
      }
      .content{
        margin-bottom: 26px;
        min-width: 180px;
        width: fit-content;
        display: inline-flex;
        flex-direction: column;
        align-items: flex-start;
        box-sizing: border-box;
        p:nth-child(1){
          text-align: left;
          height: 20px;
          font-size: 16px;
          color: #fff;
          width: fit-content;
          min-width: 0;
          white-space: nowrap;
        }
        p:nth-child(2){
          height: 20px;
          margin-top: 10px;
          font-size: 12px;
          color: #9EB4D8;
        }
      }
      .content:hover{
        p:nth-child(1){
          color: #FF9800;
        }
      }
    }

  }
}
.header_right_balck{
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 6px;
  color: #333333 ;
  position: relative;
  padding-right: 92px;
  box-sizing: border-box;
  .nav-wrap{
    position: relative;
    display: flex;
    align-items: center;
    flex-shrink: 0;
  }
  .item{
  z-index: 9999 !important;
    margin-left: 20px;
    padding-left: 10px;
    /* 修复：rpx 改为 px，并禁止压缩、避免换行挤压 */
    min-width: 128rpx;
    flex-shrink: 0;
    white-space: nowrap;
  }
  .item:hover{
    color: #1C51A3;
    border-top: 2px solid #1C51A3;
    font-weight: 550;
  }
  .lang-switch{
    position: relative;
    right: auto;
    top: auto;
    transform: none;
    margin-left: 12px;
    color: #1C51A3;
    flex-shrink: 0;
    z-index: 1300;
    white-space: nowrap;
    background: transparent;
    border: 0;
    padding: 0 8px;
    font-size: 16px;
    line-height: 1;
  }
  .lang-switch-en{
    min-width: 112px;
    padding: 0 16px;
  }
  .lang-switch:hover,
  .lang-switch:focus{
    color: #FF9800;
    background: transparent;
  }
  .about-menu{
    display: none;
    position: fixed;
    left: 0;
    top: 80px;
    width: 100vw;
    min-width: 100vw;
    margin-left: 0;
    right: 0;
    background: #1C51A3;
    z-index: 1200;
    padding: 62px 0 68px;
    box-shadow: 0 10px 30px rgba(0,0,0,.12);
    box-sizing: border-box;
    &.show{
      display: block;
    }
    .inner-xc{
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 48px;
      width: 100%;
      max-width: 1200px;
      margin: 0 auto;
      box-sizing: border-box;
      .desc{
        width: 780px;
        color: #fff;
        transform: translateY(-26px);
        .title{
          font-size: 28px;
          font-weight: 600;
          margin-bottom: 16px;
        }
        .content{
          text-align: left;
          font-size: 16px;
          line-height: 2;
        }
      }
      .navbar{
        width: 560px;
        transform: translateY(10px);
        .xc-navbar{
          display: grid;
          grid-template-columns: repeat(3, minmax(0, 1fr));
          gap: 24px 49px;
          .item{
            width: 133%;
            height: 38px;
            margin-left: 0;
            padding: 0 20px;
            box-sizing: border-box;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            background: #FF9800;
            color: #fff;
            border-top: 0;
            font-size: 14px;
            text-decoration: none;
            .arr{
              margin-right: 4px;
              flex-shrink: 0;
            }
          }
        }
      }
    }
  }
  &:not(.menu-hidden) .productMenu:hover{
    display: flex;
  }
}

/* 隐藏测量容器样式 */
.measure{
  position: absolute;
  visibility: hidden;
  left: -9999px;
  top: -9999px;
  display: block;
}
.measure .mitem{
  padding: 0 12px;
  height: 30px;
  line-height: 30px;
  white-space: nowrap;
}



  ::v-deep .el-tabs__active-bar{
    position: absolute;
    top: 0;
    left: 0;
    height: 2px;
    background-color: #1C51A3;
    z-index: 1;
    transition: transform .3s cubic-bezier(.645,.045,.355,1);
    list-style: none;
  }
  ::v-deep .el-tabs__item.is-active{
    font-weight: 550;
    color: #1C51A3;
  }
	::v-deep .el-tabs__nav-wrap::after {
		background: rgba(0, 0, 0, 0);
	}

	::v-deep .header_right_white .el-tabs__item.is-active {
		color: #3078E7;
		font-size: 18px;
	}
	::v-deep .header_right_white .el-tabs__item {
		color: #3078E7;
		font-size: 17px;
		padding: 0 25px;
	}
	::v-deep .header_right_white .el-tabs__active-bar {
		width: 56px;
		height: 8px;
		background: linear-gradient(90deg, #4B4FFF 0%, #0494FF 100%);
		border-radius: 5px;
		bottom: 28px;
		z-index: 0;
		opacity: 0.2;
	}
	::v-deep .header_right_blue .el-tabs__item.is-active {
		color: #fff;
		font-size: 18px;
	}
	::v-deep .header_right_blue .el-tabs__item {
		color: #fff;
		font-size: 17px;
		padding: 0 25px;
	}
	::v-deep .header_right_blue .el-tabs__active-bar {
		width: 56px;
		height: 8px;
		background: linear-gradient(90deg, #4B4FFF 0%, #0494FF 100%);
		border-radius: 5px;
		bottom: 28px;
		z-index: 0;
	}
	::v-deep .el-tabs__item:hover {
		color: #3078E7;
	}
</style>

<style scoped lang="scss">
	.header {
		width: 100%;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 99;
		box-shadow: 5px 0 5px rgba(0, 0, 0, 0.5);
		.showQrcode {
			border: 0;
			border-radius: 15px;
			font-size: 14px;
			height: 28px;
			width: 100px;
			line-height: 28px;
			vertical-align: middle;
			display: flex;
			justify-content: center;
			margin: 25px 0 0 40px;
		}
		.header_content {
			width: 80vw;
			height: 80px;
			line-height: 80px;
			margin: 0 auto;
			display: flex;
			justify-content: space-around;
			color: #fff;
			.header_left {
				width: 50vw;
				display: flex;
				.logo {
					margin-right: 8px;
					display: flex;
					flex-direction: column;
					justify-content: center;
					img {
						width: 181px;
						height: 43px;
					}
				}
				.title {
					width: 120px;
					font-size: 20px;
					font-weight: normal;
					color: #ffffff;
					font-weight: 700;
					letter-spacing: 0.1em;
				}
			}
		}
	}
</style>
